import styled from 'styled-components';

export const PointBadge = ({ title }: { title: string }) => {
  return (
    <PointBadgeWrapper>
      <PointBadgeText>{title}</PointBadgeText>
    </PointBadgeWrapper>
  );
};

const PointBadgeWrapper = styled.span`
  display: flex;
  padding: var(--radius-small, 4px) var(--radius-medium, 8px);
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const PointBadgeText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 18.2px */
`;
